import React, {Component} from 'react';
import "./timeline_person.scss";
import Moment from "react-moment";
import {TFunction} from "i18next";


export interface TimelinePersonData {
    title: string;
    from_interval_date: string;
    to_interval_date?: string;
    t: TFunction;
}

class TimelinePerson extends Component<TimelinePersonData> {

    render() {

        return (
            <div className="timeline-person">
                <h3>{this.props.title}</h3>
                <p>{this.props.t("C8 timeline person from")} <Moment date={this.props.from_interval_date} format="D MMMM YYYY"/>
                    {this.props.to_interval_date &&
                        <> {this.props.t("C8 timeline person to")} <Moment date={this.props.to_interval_date} format="D MMMM YYYY"/></>
                    }
                </p>
                <Moment className="timeline-year" date={this.props.to_interval_date ? this.props.to_interval_date : new Date()} format="YYYY"/>
            </div>
        );
    }
}

export default TimelinePerson;